<template>
<div id="bitacora_ws" >
  <div>
    <v-breadcrumbs :items="breadcrumbs" >
      <v-icon slot="divider" >forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <base-material-card color="primary" icon="library_books" title="Bitacora WS" class="elevation-1 px-5 py-3" >
          <br>
          <v-tabs grow style="margin-bottom: 30px;" >
            <v-tabs-slider color="primary" ></v-tabs-slider>
            <v-tab :key="'glosa'" @click="tipo=1;cargar();" >Glosa DS</v-tab>
            <v-tab :key="'diaria'" @click="tipo=2;cargar();" >Consulta Diaria</v-tab>
            <v-tab :key="'fechas'" @click="tipo=3;cargar();" >Consulta por Fechas</v-tab>
            <v-tab :key="'layout'" @click="tipo=4;cargar();" >Consulta por Layout</v-tab>
            <v-tab-item :key="'glosa'" >
                <div class="contenedor-tab-glosa" >
                    <v-card-text>
                      <v-client-table ref="vuetable" :data="datos.glosa" :columns="columns" :options="options" class="elevation-2 pa-2 scroll-table" >
                        <template slot="noResults" >
                          <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                        </template>
                        <template slot="Avance" slot-scope="props" >
                            <div class="text-right" >
                                {{props.row.Avance + "%"}}
                            </div>
                        </template>
                        <template slot="actions" slot-scope="props" >
                          <v-btn text icon color="primary" title="Descargar" v-if="props.row.Estatus=='Generado Correctamente'" @click="downloadReporte('')" >
                            <v-icon dark>get_app</v-icon>
                          </v-btn>
                        </template>
                      </v-client-table>
                    </v-card-text>
                </div>
            </v-tab-item>
            <v-tab-item :key="'diaria'" >
                <div class="contenedor-tab-diaria" >
                    <v-card-text>
                      <v-client-table ref="vuetable" :data="datos.diaria" :columns="columns" :options="options" class="elevation-2 pa-2 scroll-table" >
                        <template slot="noResults" >
                          <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                        </template>
                        <template slot="Avance" slot-scope="props" >
                            <div class="text-right" >
                                {{props.row.Avance + "%"}}
                            </div>
                        </template>
                        <template slot="actions" slot-scope="props" >
                          <v-btn text icon color="primary" title="Descargar" v-if="props.row.Estatus=='Generado Correctamente'" @click="downloadReporte('')" >
                            <v-icon dark>get_app</v-icon>
                          </v-btn>
                        </template>
                      </v-client-table>
                    </v-card-text>
                </div>
            </v-tab-item>
            <v-tab-item :key="'fechas'" >
                <div class="contenedor-tab-fechas" >
                    <v-card-text>
                      <v-client-table ref="vuetable" :data="datos.fechas" :columns="columns" :options="options" class="elevation-2 pa-2 scroll-table" >
                        <template slot="noResults" >
                          <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                        </template>
                        <template slot="Avance" slot-scope="props" >
                            <div class="text-right" >
                                {{props.row.Avance + "%"}}
                            </div>
                        </template>
                        <template slot="actions" slot-scope="props" >
                          <v-btn text icon color="primary" title="Descargar" v-if="props.row.Estatus=='Generado Correctamente'" @click="downloadReporte('')" >
                            <v-icon dark>get_app</v-icon>
                          </v-btn>
                        </template>
                      </v-client-table>
                    </v-card-text>
                </div>
            </v-tab-item>
            <v-tab-item :key="'layout'" >
                <div class="contenedor-tab-layout" >
                    <v-card-text>
                      <v-client-table ref="vuetable" :data="datos.layout" :columns="columns" :options="options" class="elevation-2 pa-2 scroll-table" >
                        <template slot="noResults" >
                          <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                        </template>
                        <template slot="Avance" slot-scope="props" >
                            <div class="text-right" >
                                {{props.row.Avance + "%"}}
                            </div>
                        </template>
                        <template slot="actions" slot-scope="props" >
                          <v-btn text icon color="primary" title="Descargar" v-if="props.row.Estatus=='Generado Correctamente'" @click="downloadReporte('')" >
                            <v-icon dark>get_app</v-icon>
                          </v-btn>
                        </template>
                      </v-client-table>
                    </v-card-text>
                </div>
            </v-tab-item>
          </v-tabs>
        </base-material-card>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  components: {},
  created: function() {
    this.URL = this.$hostname + "reportes_ws/";
    this.loading = false;
    this.rfc = this.$local_storage.get("rfc");
    this.tipo = 1;
    this.cargar();
  },
  data: () => ({
    fab: false,
    rfc:'',
    tipo:'',
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
          text: "E-Drive",
          disabled: true,
          to: ""
      },      
      {
        text: "Biracora WS",
        disabled: true,
        to: ""
      }
    ],
    datos:{
        glosa:[],
        diaria:[],
        fechas:[],
        layout:[]
    },
    columns: ["Proceso", "Referencia", "Fecha", "Fecha_De", "Fecha_A", "Estatus", "Avance"],
    options: {
      filterable: false,
      headings: {
        Proceso: "Proceso",
        Referencia: "Referencia",
        Fecha: "Fecha",
        Fecha_De: "De",
        Fecha_A: "A",
        Estatus: "Estatus",
        Avance: "Avance"
      }
    },
    loading: false,
    show_loading: true,
  }),
  methods: {
    cargar: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR...');
      let data = {
        rfc: this.rfc,
        tipo: this.tipo
      };

      axios.post(this.URL + "bitacora_ws/", data)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.datos = res.data;
          }
        })
        .catch(err => {
         console.log(err);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },
    downloadFile: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = "_blank";
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
  },
};
</script>
<style scoped>
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active), .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon, .theme--light.v-tabs > .v-tabs-bar .v-tab--disabled {
    color:black;
    font-size: small ;
    background-color: #EEEEEE;
    padding: 0px;
}
.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small ;
    background-color: #df7205;
    padding: 0px;
    font-weight: bold;

}
.v-tabs-slider-wrapper {
    left: 0 !important;
}
.table-bordered thead th, .table-bordered thead td {
    font-size: x-small !important;
}
</style>
